/**
 * VisuelCard.jsx — Affiche une infographie pédagogique voiturette
 * de façon uniforme dans les séquences (S2, S4, S5).
 *
 * Props :
 *   - visuel   : objet issu de data/cours/permisAmVoiturette/visuels.js
 *   - compact  : true = variante mini (dans une compétence),
 *                false = variante bannière (pleine largeur, header de bloc).
 *   - testid   : optionnel, ajoute un data-testid pour tests
 */
import React from 'react';
import { ImageIcon } from 'lucide-react';

export function VisuelCard({ visuel, compact = false, testid }) {
  if (!visuel) return null;

  return (
    <figure
      className={`rounded-2xl overflow-hidden border-2 bg-white ${compact ? '' : 'shadow-2xl'}`}
      style={{
        borderColor: `${visuel.color}55`,
        boxShadow: compact ? undefined : `0 20px 60px -20px ${visuel.color}44`,
      }}
      data-testid={testid || `visuel-voiturette-${visuel.id}`}
    >
      <img
        src={visuel.src}
        alt={visuel.title + ' — ' + visuel.subtitle}
        className="w-full h-auto block"
        loading="lazy"
      />
      {!compact && (
        <figcaption className="bg-black/40 backdrop-blur px-4 py-2 flex items-center gap-2 text-[11.5px] text-white/80 italic border-t" style={{ borderColor: `${visuel.color}55` }}>
          <ImageIcon className="w-3.5 h-3.5 shrink-0" style={{ color: visuel.color }} />
          <span className="font-black uppercase tracking-widest text-[10px] not-italic" style={{ color: visuel.color }}>
            {visuel.kicker}
          </span>
          <span className="text-white/60">·</span>
          <span>{visuel.caption}</span>
        </figcaption>
      )}
    </figure>
  );
}

export default VisuelCard;
